import { Component, Input } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';

import {
  AddApplicationsAdmin,
  DeleteApplicationsAdmin,
} from '../../../../../core/shared/actions/admin.actions';
import { ConfirmationModalComponent } from '../../../../../core/shared/components/modals/confirmation-modal/confirmation-modal.component';
import { Admin } from '../../../../../core/shared/models/admin.model';
import { NoWhiteSpaceValidator } from '../../../../../core/shared/validators/whitespace-validator';

@Component({
  selector: 'app-application-admin-modal',
  templateUrl: './application-admin-modal.component.html',
  styleUrls: ['./application-admin-modal.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, MatSnackBarModule, MatFormField, MatLabel, MatInput, MatError, MatIcon, MatButton, MatIconButton],
})
export class ApplicationAdminModalComponent {
  @Input() public applicationName!: string;
  @Input() public formMode = 'New';
  @Input() public editAdmin = false;
  @Input() public admin?: Admin;
  private formSubscription: Subscription = new Subscription();
  entryForm!: FormGroup;
  error: string | undefined;

  constructor(
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private store: Store,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    this.createForm();
  }

  ngOnInit() {
    if (this.admin) {
      this.entryForm.patchValue({
        application: this.admin.application,
        admin_email: this.admin.admin_email,
        Description: this.admin.Description,
      });

      this.editAdmin = true;
      //this.entryForm.get("ApplicationName")?.disable();
    } else {
      this.editAdmin = false;
    }
  }

  // Handle Create  update button click
  onCreate_Update(): void {
    this.entryForm.controls['application'].setValue(this.applicationName);

    this.formSubscription.add(
      this.store
        .dispatch(
          new AddApplicationsAdmin(this.applicationName, this.entryForm.value)
        )
        .subscribe(
          (resp: any) => {
            this.activeModal.close();
            this.showSnackBar('Admin list updated successfully!', false);
          },
          (error) => {
            this.activeModal.close();
            this.showSnackBar('An error occurred:' + error.error.message, true);
          }
        )
    );
  }

  openConfirmModal(message: string) {
    // Open modal form component
    const modalRef = this.modalService.open(ConfirmationModalComponent, {});
    modalRef.componentInstance.message = message;
    modalRef.result.then((event) => {
      if (event == 'confirm') {
        this.onDelete();
      }
    });
  }
  // Handle Create button click

  // Handle Delete button click
  onDelete() {
    this.store
      .dispatch(
        new DeleteApplicationsAdmin(
          this.applicationName,
          this.entryForm.controls['admin_email'].value
        )
      )
      .subscribe(
        (resp: any) => {
          this.activeModal.close();
          this.showSnackBar('The Admin has been successfully deleted!!', false);
        },
        (error) => {
          this.activeModal.close();
          this.showSnackBar('An error occurred:' + error.error.message, true);
        }
      );
  }

  // reactive form
  private createForm() {
    this.entryForm = this.formBuilder.group({
      application: [''],
      admin_email: new FormControl('', [
        Validators.required,
        NoWhiteSpaceValidator.cannotContainSpace,
      ]),
      Description: new FormControl('', [Validators.required]),
    });
  }

  get f() {
    return this.entryForm.controls;
  }
  showSnackBar(message: string, isError: boolean): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000, // Duration in milliseconds
      panelClass: isError ? 'error-snackbar' : 'success-snackbar', // Custom CSS classes for styling
    });
  }
  clearForm() {
    this.entryForm.reset();
  }
}
